const collection = {
    slug: "comme-des-garcons-homme-plus-2025aw-to-hell-with-war-guide",
    metaTitle:
      "コムデギャルソンオムプリュス 2025AWとは｜TO HELL WITH WARと買取・レンタルガイド",
    metaDescription:
      "COMME des GARÇONS HOMME PLUS 2025AW『TO HELL WITH WAR』を解説。川久保玲が戦争へのアンチテーゼとして提示した、ナポレオンジャケット、軍靴、ヘルメット、花、刺繍、ミリタリーの解体と再構築を読み解きます。2025AWアイテムの買取相談、コムデギャルソンオムプリュスのレンタル、ブランド一覧への導線までEnclopediaが詳しく案内します。",
    metaKeywords:
      "コムデギャルソンオムプリュス 2025AW,COMME des GARCONS HOMME PLUS 2025AW,TO HELL WITH WAR,コムデギャルソンオムプリュス TO HELL WITH WAR,コムデギャルソンオムプリュス 買取,COMME des GARCONS HOMME PLUS 買取,コムデギャルソンオムプリュス レンタル,COMME des GARCONS HOMME PLUS レンタル,コムデギャルソンオムプリュス ミリタリー,コムデギャルソンオムプリュス ナポレオンジャケット,コムデギャルソンオムプリュス 軍靴,コムデギャルソンオムプリュス アーカイブ,コムデギャルソンオムプリュス 名作,川久保玲 戦争,コムデギャルソン 買取,COMME des GARCONS 買取,Enclopedia,アンクロペディア",
    canonicalPath:
      "/archive_collection/comme-des-garcons-homme-plus-2025aw-to-hell-with-war-guide",
    heroImage:
      "media/archive_fashion/archive16.png",
    heroImageAlt:
      "COMME des GARÇONS HOMME PLUS 2025AW TO HELL WITH WARを解説するEnclopediaアーカイブガイド画像",
    heroNumber: "15 / TO HELL WITH WAR",
    label: "ARCHIVE COLLECTION STUDY",
    title:
      "COMME des GARÇONS HOMME PLUS 2025AW『TO HELL WITH WAR』",
    lead:
      "COMME des GARÇONS HOMME PLUS 2025AW『TO HELL WITH WAR』。\n\nテーマは、戦争へのアンチテーゼ。\n川久保玲はこのシーズンで、ミリタリーを単なる装飾や流行として扱っていません。\nナポレオンジャケット、オフィサージャケット、軍靴、ヘルメット。\n戦争を連想させる服の記号を使いながら、それをそのまま肯定するのではなく、解体し、ずらし、花や刺繍によって別の意味へ反転させています。\n\n軍服は本来、命令、階級、規律、暴力、国家の身体を作る服です。\nしかしこのコレクションでは、その軍服が壊され、花に覆われ、平和への願いを抱えた服として現れる。\n\nEnclopediaでは、この2025AWを、単なるミリタリーコレクションではなく、コムデギャルソンオムプリュスが男性服の中にある暴力性と制度性を問い直したシーズンとして読み解きます。",
    keywordLine: [
      "to hell with war",
      "anti-war",
      "military deconstruction",
      "homme plus buyback",
    ],
    thesis:
      "2025AW『TO HELL WITH WAR』の重要性は、軍服を美化するのではなく、軍服が背負う暴力性を解体し、花や刺繍によって平和への反転を試みた点にあります。",
    whyTitle:
      "なぜHOMME PLUSは、戦争に反対するために軍服を使ったのか。",
    whyBody:
      "戦争に反対するなら、軍服を避けることもできます。\nしかしCOMME des GARÇONS HOMME PLUS 2025AWは、あえて軍服を正面から扱いました。\n\nナポレオンジャケット、オフィサージャケット、軍靴、ヘルメット。\nこれらは、戦争や軍事的な秩序を思い起こさせる強い記号です。\nただし川久保玲は、それらを力強く見せるために使ったわけではありません。\n\n軍服を解体し、ボタンを機能から外し、フロントパーツを垂れ下がらせ、ヘルメットをターバンや花で覆う。\n戦うための服を、戦えない服へ変える。\n命令や規律の服を、祈りや抵抗の服へ変える。\n\nこのコレクションの強さは、ミリタリーを否定するためにミリタリーを使っている点にあります。\n暴力の記号を借りながら、その内部から暴力を無効化しようとする。\nそこにHOMME PLUSらしい反骨精神があります。\n\nEnclopediaでは、この文脈を入口に、2025AWの買取相談、コムデギャルソンオムプリュス全体のレンタル体験、そしてブランドページへの導線を設計します。",
    pillars: [
      {
        number: "01",
        title: "MILITARY AS TARGET",
        text:
          "2025AWのミリタリーは、憧れの記号ではありません。批評の対象です。軍服を使いながら、その中にある階級性、命令、暴力の構造を問い直しています。",
      },
      {
        number: "02",
        title: "FLOWERS AGAINST WAR",
        text:
          "ヘルメットを覆う花、フラワー刺繍、装飾的なヘッドピースは、戦争の記号に対して平和や祈りのイメージを重ねるための要素です。",
      },
      {
        number: "03",
        title: "BUYBACK FIRST, RENTAL NEXT",
        text:
          "2025AWは今後市場に流通し始める最新アーカイブ候補です。Enclopediaでは、買取相談を入口に、コムデギャルソンオムプリュス全体のレンタル体験へも接続します。",
      },
    ],
    readingTitle:
      "軍服、花、解体、反戦から読む『TO HELL WITH WAR』。",
    readingIntro:
      "このコレクションは、単にミリタリーを取り入れた服ではありません。なぜ軍服なのか、なぜ花なのか、なぜ壊れたナポレオンジャケットなのかを見ることで、川久保玲が戦争に対してどのように服で応答したのかが見えてきます。",
    observations: [
      {
        index: "01",
        title:
          "軍服は、男性服の中でも最も制度的な服である",
        text:
          "軍服は、ただのユニフォームではありません。\n階級、命令、国家、規律、暴力、集団への服従を身体に刻み込む服です。\n\nナポレオンジャケットやオフィサージャケットは、装飾的で美しく見える一方で、軍事的な権威や支配の記憶を持っています。\nコムデギャルソンオムプリュス 2025AWは、その記号をただ借りるのではなく、そこにある制度性を問い直しています。\n\n軍服を美しく見せるのではなく、軍服が持つ暴力性を服の中で露出させる。\nここに、このシーズンの出発点があります。",
      },
      {
        index: "02",
        title:
          "ナポレオンジャケットは、権威の服として解体される",
        text:
          "ナポレオンジャケットは、軍服の中でも非常に象徴的なアイテムです。\n装飾的なボタン、強い前身頃、威厳のあるシルエット。\nそれは権威を演出する服でもあります。\n\nしかし2025AWでは、そのジャケットが完全な権威としては現れません。\n過剰なボタンは本来の機能を失い、フロントパーツは垂れ下がり、構造はどこか壊れている。\n\nつまり、権威の服が、権威として立ち上がれない。\nこの崩れ方が、戦争への批評として機能しています。",
      },
      {
        index: "03",
        title:
          "つま先が90度上がった軍靴は、進軍する身体を止める",
        text:
          "軍靴は、本来なら進むための靴です。\n歩く、行進する、前線へ向かう。\n軍服の中でも、身体を戦争へ運ぶための道具に近い存在です。\n\nしかし2025AWでは、つま先が90度上に向いた軍靴が登場します。\nその形は、前へ進む身体をどこかぎこちなく見せる。\n戦うための靴が、戦いに向かう機能から外されているようにも見えます。\n\nEnclopediaの視点では、この軍靴は単なる奇抜な靴ではありません。\n進軍のための身体を、服の側から停止させる装置として読めます。",
      },
      {
        index: "04",
        title:
          "ヘルメットを覆う花は、戦争の記号を祈りへ変える",
        text:
          "ヘルメットは、戦場で頭部を守るための道具です。\nそこには戦争、兵士、危険、暴力の記憶があります。\n\n2025AWでは、そのヘルメットがターバンや花の装飾に覆われます。\n守るための硬い道具が、柔らかく、儀式的で、祈りのような装飾に包まれる。\n\nこれは単なる飾りではありません。\n戦争の記号を、そのまま戦争の記号として見せるのではなく、花によって意味を反転させる試みです。\n武器より花を。\n戦闘より祈りを。\nこの対比が、コレクション全体を支えています。",
      },
      {
        index: "05",
        title:
          "フラワー刺繍のベストは、ミリタリーの内側に平和を縫い込む",
        text:
          "フラワー刺繍のベストは、このシーズンを読むうえで重要なディテールです。\n軍服の上に花を置くのではなく、服の構造の中に花を縫い込む。\n\n刺繍は、時間をかけて布に刻まれる装飾です。\nそれは即物的な武器や命令とは異なる、手仕事、祈り、記憶に近い行為でもあります。\n\n軍服の構造の中に花が入ることで、服は戦うための装備ではなく、戦争への反論を抱えたアーカイブになります。",
      },
      {
        index: "06",
        title:
          "解体と再構築は、反骨精神のための方法である",
        text:
          "コムデギャルソンオムプリュスにおける解体と再構築は、単にデザインを複雑にするための技法ではありません。\n特に2025AWでは、軍服という制度的な服を壊すための方法として機能しています。\n\nパーツがずれる。\nボタンが機能を失う。\nシルエットが歪む。\nヘルメットが花に覆われる。\n\n軍服が持つ規律や統一感が、服の内部から崩れていく。\nこの崩れ方そのものが、反戦のメッセージになっています。",
      },
      {
        index: "07",
        title:
          "2015SS『Roses & Blood』から続く、血と戦争への応答",
        text:
          "川久保玲は、2015SS『Roses & Blood』でも、薔薇、血、戦争、政治、宗教、革命のイメージを扱いました。\nそこでは赤が、美しさの中に潜む暴力性を露わにしていました。\n\n2025AW『TO HELL WITH WAR』では、その視点がさらに直接的になります。\n赤い象徴ではなく、軍服そのものを扱う。\n美の中にある暴力ではなく、戦争の記号そのものを解体する。\n\n10年を隔てて、コムデギャルソンオムプリュスはより明確に、戦争に対する拒否を服で示しています。",
      },
      {
        index: "08",
        title:
          "2025AWは、最新でありながらすでにアーカイブ候補である",
        text:
          "2025AWは、現時点では比較的新しいシーズンです。\nしかしコムデギャルソンオムプリュスにおいて、軍服、反戦、解体、花、男性服の制度性というテーマは、ブランド史の中でも強い文脈を持ちます。\n\nこのようなシーズンは、時間が経ってからアーカイブ価値が見直されやすい領域です。\nEnclopediaでは、2025AWを単なる新作情報としてではなく、将来的なアーカイブ候補として見ます。\n\n買取相談では、タグ、シーズン、ルックとの近さ、状態、サイズ、素材、付属品まで含めて確認します.",
      },
      {
        index: "09",
        title:
          "レンタルで分かるのは、ミリタリーが無効化される身体感覚",
        text:
          "コムデギャルソンオムプリュスの服は、画像だけで見ると“ミリタリー風”や“装飾的な服”として見えます。\nしかし実際に着ると、軍服の硬さ、ジャケットの崩れ、靴の違和感、花の装飾との緊張関係が身体感覚として分かります。\n\n戦うための服が、戦えない服へ変わる。\n権威を示す服が、祈りや反骨の服へ変わる。\n\nその感覚は、実物体験と相性がいい。\nEnclopediaでは、記事で背景を読み、レンタルで身体感覚として確かめる導線を作ります.",
      },
    ],
    quote:
      "TO HELL WITH WARは、軍服を着るためのコレクションではない。軍服が背負う暴力性を、服の内側から無効化するコレクションです。",
    perspectiveTitle:
      "Enclopediaは、コムデギャルソンオムプリュスを“見る服”ではなく“着て理解する思想のアーカイブ”として扱う。",
    perspectiveCards: [
      {
        number: "01",
        title: "BUYBACK FIRST",
        text:
          "2025AWは今後流通が増えていく最新アーカイブ候補です。Enclopediaでは、コムデギャルソンオムプリュス 2025AWの買取相談を、シーズン文脈込みで受け付けます。",
      },
      {
        number: "02",
        title: "RENTAL EXPERIENCE",
        text:
          "コムデギャルソンオムプリュスのミリタリーやテーラードは、実際に着ることで理解が深まります。構造、重心、装飾、身体との距離をレンタルで体験できる導線へつなげます。",
      },
    ],
    experienceTitle:
      "コムデギャルソンオムプリュス 2025AWを売る前に、その一着がどの文脈にあるかを確認する。",
    experienceBody:
      "COMME des GARÇONS HOMME PLUS 2025AWの買取では、ブランド名だけでなく、シーズン、テーマ、ルック、素材、状態、サイズ、現在の需要が重要です。\n今回の記事では『TO HELL WITH WAR』を中心に解説していますが、Enclopediaが見ているのは2025AWだけではありません。\nCOMME des GARÇONS HOMME PLUS全般、COMME des GARÇONS、COMME des GARÇONS HOMME、JUNYA WATANABE、noir kei ninomiyaなど、コムデギャルソン全体を対象に、その一着がどの時代のどんな価値を持つのかを確認します。\n\n最新シーズンを知ることは、これから市場に出てくる一着の価値を早く見極める入口になります。",
    experienceItems: [
      "COMME des GARÇONS HOMME PLUS 2025AWのタグ・シーズンを確認する",
      "TO HELL WITH WARに近いナポレオンジャケット、オフィサージャケット、ミリタリーディテールを撮影する",
      "フラワー刺繍、ヘッドピース、軍靴、解体的なパーツがある場合は重点的に撮影する",
      "ショールックとの近さ、サイズ、状態、購入時期、付属品を確認する",
      "コムデギャルソンオムプリュス以外のコムデギャルソンラインも相談する",
      "2025AWか不明な場合もLINEで写真を送る",
    ],
    archiveItemsTitle:
      "2025AWを入口に、コムデギャルソンオムプリュスの買取・レンタルへつなげる。",
    archiveItemsBody:
      "Enclopediaでは、COMME des GARÇONS HOMME PLUSを単なるブランド古着としてではなく、川久保玲の男性服への問い、シーズン背景、現在の需要まで含めて見ています。この記事で2025AWの重要性に触れた方は、所有しているHOMME PLUSの一着も、まずはLINEでご相談ください。",
    archiveItems: [
      {
        label: "BUYBACK FOCUS 01",
        title: "COMME des GARÇONS HOMME PLUS買取ページへ",
        productPath:
          "/brand_buyback/comme-des-garcons-homme-plus",
        productImage: "",
        text:
          "2025AW TO HELL WITH WARを含むコムデギャルソンオムプリュスのジャケット、パンツ、スーツ、シャツ、ミリタリー要素のあるアーカイブまで。オムプリュスの買取対象と査定視点を確認できます。",
      },
      {
        label: "RENTAL FOCUS 02",
        title: "レンタルできるコムデギャルソンオムプリュスを見る",
        productPath:
          "/brand/COMME%20DES%20GARCONS%20HOMME%20PLUS（コムデギャルソンオムプリュス）/?number=11",
        productImage: "",
        text:
          "コムデギャルソンオムプリュスのシーズン性やシルエットは、実際に着ることで理解が深まります。Enclopediaでコムデギャルソンオムプリュスのアーカイブを体験できます。",
      },
      {
        label: "BRAND FOCUS 03",
        title: "TO HELL WITH WARを読んだら、次はコムデギャルソンオムプリュスの価値を相談する。",
        productPath:
          "https://line.me/R/ti/p/@240yzqkh",
        productImage: "",
        text:
          "COMME des GARÇONS HOMME PLUS 2025AWは、軍服を美化するのではなく、戦争へのアンチテーゼとしてミリタリーを解体したシーズンです。\nEnclopediaでは、2025AWの買取相談を入口に、HOMME PLUS全体のレンタル体験やブランド一覧へつなげます。\nまずはLINEでタグ・品質表示・全体写真をお送りください。",
      },
    ],
    finalCta: {
      title:
        "TO HELL WITH WARを読んだら、次はコムデギャルソンオムプリュスの価値を相談する。",
      body:
        "COMME des GARÇONS HOMME PLUS 2025AWは、軍服を美化するのではなく、戦争へのアンチテーゼとしてミリタリーを解体したシーズンです。\nEnclopediaでは、2025AWの買取相談を入口に、HOMME PLUS全体のレンタル体験やブランド一覧へつなげます。\nまずはLINEでタグ・品質表示・全体写真をお送りください。",
      buttonLabel: "コムデギャルソンオムプリュスをLINEで事前査定する",
      buttonHref: "https://line.me/R/ti/p/@240yzqkh",
    },
  };
  
  export default collection;